module.exports = __webpack_public_path__ + "img/1-1.032db3b7.png";